import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ActivityLogClickDirective } from '@client-ui/directives/activity-log-click.directive';
import { IconComponent } from '@shared-lib/components/icon/icon.component';
import { IconNameModel } from '@shared-lib/components/icon/models/icon-name.model';
import { MultiactionButtonComponent } from '@shared/components/multiaction-button/multiaction-button.component';
import { ANALYTIC_CLICK_EVENT_NAMES } from '@shared/constants/analytic-click-event-names';
import { NavigationService } from '@shared/services/navigation.service';
import { MenuItem } from 'primeng/api';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'cp-detail-header',
  imports: [ButtonDirective, IconComponent, MultiactionButtonComponent, NgClass, ActivityLogClickDirective],
  templateUrl: './detail-header.component.html',
  styleUrl: './detail-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailHeaderComponent {
  @Input({ required: true }) headline: string;
  @Input() isMenuVisible = false;
  @Input() isBackButtonVisible = true;
  @Input() isActionButtonVisible = false;
  @Input() menuItems: MenuItem[] = [];
  @Input() actionIcon: IconNameModel;
  @Input() actionIconSize: string;
  @Input() actionButtonActivityLogName: string;
  @Input() buttonClass: string;
  @Input() titleSize: 'small' | 'medium' = 'medium';
  @Input() variant: 'light' | 'light-gold' | 'light-gray-turquoise' | 'remortgage-guide' | 'better-deal' | 'light-gray' | 'bg-gray-5' =
    'light';

  @Input() hasCustomBackAction = false;
  @Output() actionClicked = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  private readonly navigationService = inject(NavigationService);

  protected readonly AnalyticClickEventNames = ANALYTIC_CLICK_EVENT_NAMES;

  backClicked(): void {
    if (this.hasCustomBackAction) return this.back.emit();
    this.navigationService.back();
  }

  emitActionClicked(): void {
    this.actionClicked.emit();
  }
}
